export default __webpack_public_path__ + "static/media/avatar2.b305dde4.png";